export type BridgeToastPayload = {
  message: string;
  type?: 'success' | 'error' | 'info' | 'warning';
  duration?: number;
  details?: string;
};

type ToastPresenter = (payload: BridgeToastPayload) => void;

let toastPresenter: ToastPresenter | null = null;

export const registerToastPresenter = (presenter: ToastPresenter): (() => void) => {
  toastPresenter = presenter;
  return () => {
    if (toastPresenter === presenter) {
      toastPresenter = null;
    }
  };
};

export const showBridgeToast = (payload: BridgeToastPayload): void => {
  toastPresenter?.(payload);
};
